<!--STAR Menu-->
<header>
    <app-navbar>

    </app-navbar>

</header>

<!--Start Content-->
<router-outlet></router-outlet>
<!--START Footer-->
<footer>

</footer>